import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import numeral from 'numeral';

export default class CommissionLabel extends Component {
  render() {
    const { price, buyprice, isPackage = false } = this.props;
    const result = buyprice > 0 && price - buyprice > 0 ? price - buyprice : 0;

    if (isPackage) {
      return '';
    }

    return (
      <Row>
        <Col md={3}>
          <div
            className="form-group"
            style={{
              padding: 6,
              backgroundColor: '#3d91ff',
              borderRadius: '8px',
            }}
          >
            <b style={{ paddingLeft: 8 }}>{`Comisión: $${numeral(result).format(
              '0.00'
            )}`}</b>
          </div>
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CommissionLabel.js